/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Reflex API
 * OpenAPI spec version: 1.0.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetProfileStatsParams
} from './model/getProfileStatsParams.js';

import type {
  ProfileStatsResponse
} from './model/profileStatsResponse.js';

import { apiFetch } from '../react-mutator.js';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary Get a user's agent run stats for a year.
 */
export const getProfileStats = (
    params?: GetProfileStatsParams,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<ProfileStatsResponse>(
      {url: `/profile/stats`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetProfileStatsQueryKey = (params?: GetProfileStatsParams,) => {
    return [
    `/profile/stats`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetProfileStatsQueryOptions = <TData = Awaited<ReturnType<typeof getProfileStats>>, TError = unknown>(params?: GetProfileStatsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProfileStats>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProfileStatsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProfileStats>>> = ({ signal }) => getProfileStats(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProfileStats>>, TError, TData> & { queryKey: QueryKey }
}

export type GetProfileStatsQueryResult = NonNullable<Awaited<ReturnType<typeof getProfileStats>>>
export type GetProfileStatsQueryError = unknown


/**
 * @summary Get a user's agent run stats for a year.
 */

export function useGetProfileStats<TData = Awaited<ReturnType<typeof getProfileStats>>, TError = unknown>(
 params?: GetProfileStatsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProfileStats>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetProfileStatsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






